import React from 'react';

const PasswordNotVisibleIcon: React.FunctionComponent = () => {
  return (
    <svg width="20" height="15" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.63 15.63a8.7 8.7 0 0 1-5.13 1.779c-6.045 0-9.5-6.91-9.5-6.91a15.9 15.9 0 0 1 4.37-5.13M8.686 3.8a8 8 0 0 1 1.814-.21c6.046 0 9.5 6.909 9.5 6.909-.524.98-1.15 1.904-1.866 2.755m-5.803-.924a2.59 2.59 0 1 1-3.662-3.662M1 1l18 18"
        stroke="#865CD0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PasswordNotVisibleIcon;
